import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';
import { selectStyles } from '../../../components/dropDown/selectStyle';
import RecoverModal from '../../../components/modals/recoverModal';
import DeleteModal from '../../../components/modals/deleteModal';
import ViewModal from '../../../components/modals/viewModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';
import { statusFormatter } from '../../../components/formatters/defFormatter';

import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter, FiFilter  } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcViewDetails, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function Logs(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, defaultCurrency, mainCurrency, yearId, companyId, userId, allUserOptions, refData, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['user']
        await refData(dataArray, userId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);



  const table = 'userLogs';
  const title = 'Logs';


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today, userId: null, });



  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);


  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e?.journalVoucherId);
    }
    setShowViewModal(!showViewModal);
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const openModal = (e) => {
    if (!showModal && e) {
      setIdRow(e);
    }
    else {
      setIdRow(null);
    }
    setShowModal(!showModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        ID: item.id,
        User: item.created?.name,
        Opened: dateTableFormatter(item.openedAt),
        Closed: dateTableFormatter(item.closedAt),
        Opening: isUsingMainCurrency ? numberFormatter(item.openingBalance) : numberFormatter(item.secondaryOpeningBalance),
        Closing: isUsingMainCurrency ? numberFormatter(item.closingBalance) : numberFormatter(item.secondaryClosingBalance),
        Balance: isUsingMainCurrency ? numberFormatter(item.balance) : numberFormatter(item.secondaryBalance),
        Variance: isUsingMainCurrency ? numberFormatter(item.variance) : numberFormatter(item.secondaryVariance)
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  const isUsingMainCurrency = defaultCurrency.id == mainCurrency.id ? true : false;

  const newColumnDefs = useMemo(() => [
    { title: contentLanguages.ID, dataIndex: 'id' },
    { title: contentLanguages.JvId, dataIndex: 'journalVoucherId' },
    { title: contentLanguages.SessionId, dataIndex: 'sessionId' },
    { title: contentLanguages.Date, dataIndex: 'createdAt', render: dateTableFormatter },
    { title: contentLanguages.User, dataIndex: 'user', render: (user) => (user?.name) },
    { title: contentLanguages.Action, dataIndex: 'action'},
    { title: contentLanguages.Status, dataIndex: 'status', render: statusFormatter },
    {
      title: contentLanguages.View,
      width: '8%',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <FcViewDetails size={20} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
        </div>
      ),
    }
  ], []);

  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  };

  const tableFooter = (
    <div></div>
  )

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>
          <div>
            <Row className='g-2 mb-3'>

              <Col md={2}>
                <SearchFilter setFilter={setFilter} />
              </Col>

              <Col md={4}>
                <DatePicker setFilter={setFilter} filter={filter} />
              </Col>


              <Col md={2}>

                <Select
                  styles={selectStyles}
                  options={allUserOptions}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(e) => handleSelectChange(e, 'userId')}
                  value={allUserOptions?.find(option => option.value === filter.userId) || []}
                  placeholder={'Select User ... '}
                  required
                />

              </Col>

              <Col md={2}>
                
                <Button onClick={refreshTableFunction} style={{ backgroundColor: '#22566a'}}>
                  <FiFilter  size={15} color='white' />
                </Button>
              </Col>


              <Col md={2} className="d-flex justify-content-end">
                <Button onClick={refreshTableFunction}>
                  <FiPrinter size={18} />
                </Button>
                <Button onClick={refreshTableFunction}>
                  <FiRotateCcw size={18} />
                </Button>
              </Col>

            </Row>

            <SimpleTable
              filter={filter}
              table={table}
              title={title}
              columnDefs={newColumnDefs}
              idRow={idRow}
              setIdRow={setIdRow}
              refreshTable={refreshTable}
              data={data}
              setData={setData}
              tableFooter={tableFooter}
              api={api}
              getExcelData={getExcelData}
              selection={true}
              height={true}
            />

            {viewModal &&
              <ViewModal
                showModal={showViewModal}
                toggleModal={viewModal}
                journalVoucherId={idRow}
              />
            }

          </div>



        </div>
      }


    </div>
  )
}

export default Logs;
